import type { WithdrawalMode } from '@generated/graphql';
import { FlagsmithFlags } from '@utils/flagsmith';
import { useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { isWithdrawalFeatureActive } from './withdrawalMode.utils';

export type UseWithdrawalFeatureActiveProp = {
  optionEnabled: boolean;
  storedMode: WithdrawalMode | undefined;
  netAmountCents: number | undefined;
};

export const useWithdrawalFeatureActive = ({
  optionEnabled,
  storedMode,
  netAmountCents,
}: UseWithdrawalFeatureActiveProp) => {
  const flagEnabled = useFeatureFlag(FlagsmithFlags.withdrawal_net_gross);

  return isWithdrawalFeatureActive({
    flagEnabled,
    optionEnabled,
    storedMode,
    netAmountCents,
  });
};
